import React, {Fragment, useState} from "react";
import queryString from 'query-string'
import {useLocation} from 'react-router-dom'

import './UserDashboardTab.scss';
import DashboardPanelOrgChildAge from "root/dashboard/DashboardPanelOrgChildAge";
import DashboardPanelOrgUsers from "root/dashboard/DashboardPanelOrgUsers";
import {getMonthName} from "root/DataFunctions/DashboardDataFns"
import DashboardUserSummary from "root/dashboard/DashboardUserSummary";

const UserDashboardTab = (props) =>
{
    const d = new Date();
    const currentMonth = d.getMonth();
    const currentYear = d.getFullYear();

    const [month, setMonth] = useState(currentMonth);
    const [year, setYear] = useState(currentYear);

    const {search} = useLocation()
    const queryParams = queryString.parse(search);

    const displayPanel = () =>
    {
        const user_id = props.user_id !== undefined ? props.user_id : props.match.params.user_id;

        switch (queryParams.type)
        {
            case 'child-age':
                return <DashboardPanelOrgChildAge title={'Number of Children In Age Range'}/>
                break;

            case 'users':
                return <DashboardPanelOrgUsers title={'Users by Type'} team_id={'all'}/>
                break;

            case 'summary':
                return <DashboardUserSummary title={'Summary'} user_id={user_id} year={year} month={month}/>
                break;

            default:
            case 'child-age':
                return <DashboardPanelOrgChildAge title={'Number of Children In Age Range'}/>
                break;
        }
    }

    const onClickPrevious = () =>
    {
        if(month == 0){
            setMonth(11);
            setYear(curYear=> curYear - 1);
        }
        else{
            setMonth(curMonth=> curMonth - 1);
        }
    }

    const onClickNext = () =>
    {
        if(month == 11){
            setMonth(0);
            setYear(curYear=> curYear + 1);
        }
        else{
            setMonth(curMonth=> curMonth + 1);
        }
    }

    const displayDateString = () =>{
        let monthName = getMonthName(month);
        let monthString = monthName + ' ' + year;
        return <div>{monthString}</div>
    }

    return (
        <Fragment>
            <div className="family-body">
                {displayPanel()}
            </div>

            {/* Month Buttons*/}
            {(queryParams.type !== 'child-age' &&  queryParams.type !== 'users') &&
                <div className="d-flex flex-row justify-content-end">
                    <div className="family-body">
                        {displayDateString()}
                    </div>

                    <div className="p-2">
                        <button onClick={onClickPrevious} className="btn btn-primary">-<i
                            className="et-arrow-bold-left"></i></button>
                    </div>
                    <div className="p-2">
                        <button onClick={onClickNext} className="btn btn-primary">+<i
                            className="et-arrow-bold-left"></i></button>
                    </div>
                </div>
            }
        </Fragment>
    )
}

UserDashboardTab.defaultProps = {};

export default UserDashboardTab;


